import React, { ReactElement } from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  getDefaultProps,
  primaryCollectionBlock,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { webflowHOC } from "@kameleon-common/webflow-js";
import {
  backgroundColorModeMapper,
  BackgroundColors as ThemeBackgroundColors,
  Variants,
} from "@kameleon-util/global-theme";
import {
  blockConfig,
  SliderItem,
  SliderItemType,
} from "./components/slider-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { SliderType as ComponentType, layoutOptions } from "./types/prop-types";

type SliderType = {
  PrimaryBlocks: SliderItemType[];
} & ComponentType;

const SliderComponent = ({
  PrimaryBlocks,
  tagline,
  title,
  description,
  layoutProps,
}: SliderType): ReactElement => {
  const primaryBlockLayoutProps = { ...layoutProps };
  if (layoutProps?.itemBackground) {
    primaryBlockLayoutProps.backgroundColor =
      ThemeBackgroundColors.neutralLight;
  }

  return (
    <Box className="primary-collection-slider-three-col-small-media-v1">
      <Box className="section_blog65 padding-global">
        <Box className="container-large padding-section-large">
          <Box className="margin-bottom margin-xxlarge blog65_heading-wrapper blog65_heading">
            <Box className="max-width-large">
              {tagline && (
                <Box className="margin-bottom margin-xsmall">
                  <Variants.TagLine>{tagline}</Variants.TagLine>
                </Box>
              )}
              <Box className="margin-bottom margin-xsmall">
                <Variants.Heading>{title}</Variants.Heading>
              </Box>
              <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
            </Box>
          </Box>
          <Variants.Slider
            layoutProps={layoutProps}
            className="blog65_component w-slider"
          >
            <Box className="blog65_mask w-slider-mask">
              {Variants.AllowedRandomItems(layoutProps, PrimaryBlocks)?.map(
                (primaryBlockProps, i) => {
                  const primaryProps = { ...primaryBlockProps };
                  primaryProps.layoutProps = primaryBlockLayoutProps;
                  primaryProps._parentBgColor = backgroundColorModeMapper(
                    layoutProps.backgroundColor
                  ).color;
                  return (
                    <Box key={i} className="blog65_slide w-slide">
                      <SliderItem {...primaryProps} />
                    </Box>
                  );
                }
              )}
            </Box>
            <Variants.LinkButtonSlider
              left
              className="blog65_arrow left w-slider-arrow-left"
            />
            <Variants.LinkButtonSlider
              left={false}
              className="blog65_arrow w-slider-arrow-right"
            />
            <Variants.SliderNav className="blog65_slide-nav w-slider-nav w-slider-nav-invert w-round" />
          </Variants.Slider>
        </Box>
      </Box>
    </Box>
  );
};
const SliderComponentWithWebflow = webflowHOC(SliderComponent, ["slider"]);

export const Slider = primaryCollectionBlock<SliderType>(
  blockConfig,
  SliderComponentWithWebflow
);

Slider.defaultProps = getDefaultProps<SliderType>(defaults);

export const Element: KameleonElement = {
  component: Slider,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
